import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from '../styles/grid.css';
/**
 * **Column** is a sizeble vertical slice inside a grid row. You can define the number
 * of grid columns for different screen sizes.
 *
 * Allows adding arbitrary props that are allowed on `div` elements
 * (e.g. `id`, `style` or `title`)
 */
export const Column = ({ size, sizeTiny, sizeTablet, sizeConfined, sizeDesktop, sizeWide, sizeXWide, offset, offsetTiny, offsetTablet, offsetConfined, offsetDesktop, offsetWide, offsetXWide, className, ...other }) => {
    sizeConfined =
        typeof sizeConfined === 'undefined' ? sizeTablet : sizeConfined;
    sizeWide = typeof sizeWide === 'undefined' ? sizeDesktop : sizeWide;
    offsetConfined =
        typeof offsetConfined === 'undefined' ? offsetTablet : offsetConfined;
    offsetWide = typeof offsetWide === 'undefined' ? offsetDesktop : offsetWide;
    const classNames = classnames(styles.col, {
        [styles[`default${size}`]]: size || size === 0,
        [styles[`tiny${sizeTiny}`]]: sizeTiny || sizeTiny === 0,
        [styles[`confined${sizeConfined}`]]: sizeConfined || sizeConfined === 0,
        [styles[`wide${sizeWide}`]]: sizeWide || sizeWide === 0,
        [styles[`xwide${sizeXWide}`]]: sizeXWide || sizeXWide === 0,
        [styles[`defaultOffset${offset}`]]: offset || offset === 0,
        [styles[`tinyOffset${offsetTiny}`]]: offsetTiny || offsetTiny === 0,
        [styles[`confinedOffset${offsetConfined}`]]: offsetConfined || offsetConfined === 0,
        [styles[`wideOffset${offsetWide}`]]: offsetWide || offsetWide === 0,
        [styles[`xwideOffset${offsetXWide}`]]: offsetXWide || offsetXWide === 0,
    }, className);
    return _jsx("div", { className: classNames, ...other });
};
Column.displayName = 'Column';
//# sourceMappingURL=column.js.map